import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ScalableEcommerceSolutionsInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Scalable E-commerce Solutions in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Grow Without Limits</Subheading>}
        heading={
          <Heading>
            Scalable <span tw="text-primary-500">E-commerce Solutions</span> in
            Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide scalable e-commerce solutions in
            **Dubai**, designing online stores that grow with your business.
            From startups to enterprises, our platforms adapt to your needs
            seamlessly.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // E-commerce dashboard
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Business growth chart
          "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai skyline
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Scale Your Store Today"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Scalable E-commerce Excellence in Dubai"
        description="We build platforms that evolve with your success."
        cards={[
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Flexible Growth",
            description: "Easily handle increased traffic and sales.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Modular Features",
            description: "Add functionality as your business expands.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Scalability",
            description: "Tailored solutions for your unique needs.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Reliable Performance",
            description: "Stable systems even at peak demand.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Device-Agnostic",
            description: "Scales seamlessly across all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Dubai’s leader in scalable e-commerce.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Scalable Development Process"
        description={
          <Description>
            We create e-commerce stores built to scale:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Design a foundation for future growth.</li>
              <li>Architecture: Build a scalable, robust platform.</li>
              <li>
                Development: Implement flexible, high-performance features.
              </li>
              <li>Testing: Ensure stability under heavy loads.</li>
              <li>Launch: Deploy a store ready to expand.</li>
              <li>Support: Upgrade and optimize as you grow.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Team planning
          "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Business strategy
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai business district
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Scalable Success in Dubai"
        description="Our solutions fuel business growth."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Traffic Surge",
            description: "Handled 300% traffic spike seamlessly.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Rapid Expansion",
            description: "Scaled store features in just 2 weeks.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Trust",
            description: "97% satisfaction with scalability.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Scale?</Subheading>}
        heading="Scalable E-commerce Solutions in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for scalable e-commerce solutions in
            Dubai. Build an online store that grows with your vision—contact us
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Mobile e-commerce
          "https://images.unsplash.com/photo-1526458179558-6c36b2399722?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Developer coding
          "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60", // Dubai modern architecture
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
